<div class="text-right">
    <img style="width: 80%; display: block; margin-left: auto; margin-right: auto; box-shadow: 0 3px 10px 0 rgba(0,0,0,0.08); text-align: right; border: 6px solid #FFFFFF; border-bottom: 0;" src="https://alarabiya.com.kw/pub/media/banners/termsar.jpg" alt="">
    <p>&nbsp;</p>
    <p >مرحباً بك في موقع الشركة العربية للكهرباء، تنطبق هذه الشروط والأحكام على الموقع وعلى جميع أقسامه، إن إستخدامك لموقع الشركة العربية للكهرباء هو موافقة منك على القبول ببنود وشروط هذه الإتفاقية والذي يتضمن كافة التفاصيل أدناه وهو تأكيد لإلتزامك بالاستجابة لمضمون هذه الإتفاقية الخاصة بالشركة العربية للكهرباء وتعتبر هذه الإتفاقية سارية المفعول حال قبولك بخيار الموافقة</p>

    <h3 ><strong>السعر</strong></h3>
    <p >السعر المتفق عليه لحظة إصدار الطلب هو السعر المعتمد</p>
    <p >يحق للشركة العربية للكهرباء تغيير الأسعار المعلنة دون إخطار سابق</p>

    <h3 ><strong>الحساب والمستخدم المسجل لدى الموقع</strong></h3>
    <p >للوصول الي خدمة معينة لطلب وشراء المنتج ، يجب أن تقوم بإنشاء حساب على الشركة العربية للكهرباء ويكون حسابك شخصيًا وغير قابل للتحويل إلى أي طرف آخر. سوف يتم حماية معلوماتك وفقًا لسياسة الخصوصية الخاصة بنا. عندما تقوم بالتسجيل وإنشاء حساب ، يجب عليك تقديم معلومات دقيقة وحقيقية عنك بما في ذلك عنوان البريد الإلكتروني ، الاسم الأول ، الاسم الأخير ، البلد ، رقم الهاتف وأي معلومات أخرى مطلوبة لإنشاء الحساب.</p>


    <h3 ><strong>حسابك<br><br></strong></h3>
    <p >إذا كنت تستخدم موقع الشركة العربية للكهرباء ، فأنت مسؤول عن الحفاظ على سرية حسابك وكلمة المرور ومنع الوصول إلى جهاز الكمبيوتر الخاص بك، وأنت توافق على قبول المسؤولية عن جميع الأنشطة التي تتم من خلال حسابك أو كلمة المرور موقع الشركة العربية للكهرباء، كما أن الشركة العربية للكهرباء لا يبيع منتجات للأطفال، لكنه يبيعها للبالغين فقط الذين يستطيعون شراء من خلال بطاقة الائتمان أو غيرها من طرق الدفع المسموح بها. وإذا كنت تحت سن <strong>18</strong>، يمكنك استخدام الشركة العربية للكهرباء فقط مع اشتراك أحد الوالدين أو الوصي.</p>
    <p >انت ملزماً بالحفاظ على بيانات التسجيل وتحديثها تباعاً للابقاء عليها حقيقية وصحيحة ، وإذا ما أفصحت عن معلومات غير حقيقية أو غير صحيحة أوغير كاملة ، فإن الشركة العربية للكهرباء لها الحق كاملا في الغاء او تجميد عضويتك الى اجل غير مسمى و ذلك دون الحاق الاضرار و يحق لما بأستخدام الوسائل المشروعه في استرداد الحقوق</p>

    <h3 ><strong>طرق الدفع<br><br></strong></h3>
    <p >نحن نقبل ( كى نت – &nbsp;ماستر كارد – ).</p>
    <p ><u>التوصيل</u></p>
    <p >تقدم الشركة العربية للكهرباء خدمة توصيل تلبي طلبك وتوفر الكثير من زمنك ،حيث تتوفر خدمة التوصيل العادي &nbsp;خلال 24 ساعة من تاريخ الفاتورة، بقيمة ( 1 د ينار) للمناطق القريبة (و3 دنانير) للمناطق البعيدة كما تتوفر خدمة التوصيل السريع خلال 6 ساعات للمناطق القريبة بقيمة ( 3 دنانير) .</p>
    <p >في حال عدم وجود العميل في العنوان المحدد للتوصيل، سيقوم المندوب بالانتظار لمدة 10 دقائق وفي حوزته المنتجات المطلوبة. إن لم يتواجد العميل في تلك الفترة فسوف يضطر المندوب إلى الانصراف ويجب على العميل بمكالمة خدمة العملاء على رقم 22299990 لإعادة تحديد موعد الاستلام مرة اخرى</p>
    <p >في حال لم يستطيع قسم التوزيع التواصل مع العميل في غضون ٤٨ ساعة، سيتم إلغاء الطلب تلقائياً</p>



    <h3 ><strong>الطلب<br></strong>&nbsp;</h3>
    <p >يرجى العلم انة قد يكون هناك بعض الطلبات التى لا يمكنا قبولها و يجب إلغاؤها، يوجد بعض الحالات قد تؤدى الى إلغاء طلبك التى تتضمن الكميات المتاحة للشراء او خطأ فى شرح المنتج او صورة المنتج او سعر المنتج او المشكلات التى يحددها قسم الغش التجاري لدينا او الحالات التى فيها يتلاعب العميل بالحساب بوضع طلبات مختلفة، قد نطلب أيضاً معلومات إضافية قبل قبول الطلب و سوف نتصل بك اذا تم إلغاء كل او جزء من طلبك او اذا كانت هناك معلومات اضافية مطلوبة لتنفيذ طلبك و اذا تم إلغاء طلبك بعد اتمام عملية الدفع،&nbsp; فسيتم ارجاع المبلغ المذكور فى حسابك من خلال تزويدنا ببيانات حسابك بالبنك الخاص بك .</p>


    <h3 ><strong>سياسة الاستبدال و الاسترجاع<br><br></strong></h3>
    <p >اذا تم شراء منتج وأراد العميل إرجاع المنتج او استبداله فلديه 14 يوم من استلام المنتج ويجب ان يكون المنتج بحالة المصنع (يجب ان لا يكون مستعمل وان يكون سليم .</p>
    <p >في حالة تقدم المشتري طلب استرجاع المنتج لن يتم استرجاع رسوم التوصيل لان سبق تحصيله من قبلنا، وبذلك سوف نقوم برد مبلغ المنتجات التي تم شراؤها فقط اذا تم شراء منتج من قبل العميل وظهر به خلل مصنعي بعد 24 ساعه – سيقوم خدمة عملاء الشركة العربية للكهرباء بتوجيه العميل إلى مركز صيانة الشركة العربية للكهرباء.</p>
    <p >اذا تم شراء أي منتج تحت بنود الهدايا، العروض الحصرية، حملات المبيعات أو مجانية...الخ، يكون لدينا الحق في عدم قبول استرجاع المنتج أواستبداله (فقط إذا ثبت به خلل مصنعي في غضون 24 ساعة)</p>
    <p >لايمكن قبول المنتج التالف نتيجة لاستخدام خاطئ (المصادرالكهربائية، وتسرب المياه والتصليح في ورشة عمل غيرمصرح بها ... الخ) وفقا لأحكام وشروط الضمان</p>


    <h3 ><strong>طريقة استرداد المبلغ</strong></h3>
    <table class="text-right table table-striped" style="direction: rtl; text-align: right; " >
        <tbody >
        <tr>
            <td >
                <p>موعد استلام المبالغ</p>
                <p>&nbsp;</p>
            </td>
            <td >
                <p>طريقة الاسترداد</p>
                <p>&nbsp;</p>
            </td>
            <td >
                <p>طريقة الدفع</p>
                <p>&nbsp;</p>
            </td>
        </tr>
        <tr>
            <td >
                <p>في خلال 10 ايام</p>
                <p>&nbsp;</p>
            </td>
            <td >
                <p>عبر البنك</p>
                <p>&nbsp;</p>
            </td>
            <td >
                <p>كى نت</p>
                <p>&nbsp;</p>
            </td>
        </tr>
        <tr>
            <td >
                <p>في خلال 15 يوم</p>
                <p>&nbsp;</p>
            </td>
            <td >
                <p>عبر البنك</p>
                <p>&nbsp;</p>
            </td>
            <td>
                <p>فيزا / ماستر</p>
                <p>&nbsp;</p>
            </td>
        </tr>
        <tr>
            <td>
                <p>في خلال 7 ايام</p>
                <p>&nbsp;</p>
            </td>
            <td >
                <p>تسليم نقدى للعميل</p>
                <p>&nbsp;</p>
            </td>
            <td >
                <p>المبلغ نقدى</p>
                <p>&nbsp;</p>
            </td>
        </tr>
        </tbody>
    </table>
</div>
